import { render, staticRenderFns } from "./ViewRolePage.vue?vue&type=template&id=72fd1865"
import script from "./ViewRolePage.vue?vue&type=script&lang=js"
export * from "./ViewRolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports